"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralNewTierReachedEvent = exports.ReferralInvitedUsersAcceptedEvent = void 0;
const validation_1 = require("../../validation");
const base_1 = require("./base");
const utils_1 = require("./utils");
const referralMetadataSchema = {
    type: 'object',
    properties: {
        title: { type: 'string' },
        description: { type: 'string' },
        address: { type: 'string' },
        tier: { type: 'number', minimum: 1 },
        url: { type: 'string' },
        image: { type: 'string' },
        invitedUserAddress: { type: 'string' },
        invitedUsers: { type: 'number', minimum: 1 },
        rarity: { type: 'string', nullable: true }
    },
    required: ['address', 'tier', 'url', 'title', 'description', 'image', 'invitedUserAddress'],
    additionalProperties: false
};
var ReferralInvitedUsersAcceptedEvent;
(function (ReferralInvitedUsersAcceptedEvent) {
    ReferralInvitedUsersAcceptedEvent.schema = (0, utils_1.createEventSchema)(base_1.Events.Type.REFERRAL, base_1.Events.SubType.Referral.REFERRAL_INVITED_USERS_ACCEPTED, referralMetadataSchema);
    ReferralInvitedUsersAcceptedEvent.validate = (0, validation_1.generateLazyValidator)(ReferralInvitedUsersAcceptedEvent.schema);
})(ReferralInvitedUsersAcceptedEvent = exports.ReferralInvitedUsersAcceptedEvent || (exports.ReferralInvitedUsersAcceptedEvent = {}));
var ReferralNewTierReachedEvent;
(function (ReferralNewTierReachedEvent) {
    ReferralNewTierReachedEvent.schema = (0, utils_1.createEventSchema)(base_1.Events.Type.REFERRAL, base_1.Events.SubType.Referral.REFERRAL_NEW_TIER_REACHED, referralMetadataSchema);
    ReferralNewTierReachedEvent.validate = (0, validation_1.generateLazyValidator)(ReferralNewTierReachedEvent.schema);
})(ReferralNewTierReachedEvent = exports.ReferralNewTierReachedEvent || (exports.ReferralNewTierReachedEvent = {}));
//# sourceMappingURL=referral.js.map